import { useTranslation } from "react-i18next";
import ContentImage from "@/components/ContentImage";
import { EVENT_TYPES } from "@/content/eventTypes";

// The kinds of events Photohawk Studio is used for (src/content/eventTypes.ts), each with a stock photo
// (src/content/media, Pexels License: CREDITS.md) and one line on how people find their photos there. Shown on /studio, /for-organisers and
// /event-photography. Copy is home.studio.events.* (English until translated). Every line is a claim the product makes
// today: bib and text search read race and competitor numbers, selfie search, time search, collections, colour
// filters, free downloads paid by the organiser or a sponsor, and selfie search switched off per gallery (for events
// with children). Weddings and private shoots are left out on purpose: Studio is built for events people search.

/** The grid of event types: a photo, the event type and how people find their photos there, then the photo credit. */
const EventTypesGrid = ({ className = "" }: { className?: string }) => {
  const { t } = useTranslation();
  const e = (key: string) => t(`home.studio.events.${key}`);
  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      <ul className="m-0 grid list-none grid-cols-[repeat(auto-fill,minmax(min(260px,100%),1fr))] gap-5 p-0" data-testid="event-types">
        {EVENT_TYPES.map((x) => (
          <li key={x.id} className="flex flex-col overflow-hidden rounded-2xl border border-border bg-card text-card-foreground shadow-sm" data-testid={`event-type-${x.id}`}>
            <ContentImage name={x.image} sizes="(min-width: 1320px) 300px, (min-width: 640px) 45vw, 92vw" className="block aspect-[16/9] h-auto w-full object-cover" />
            <div className="flex flex-col gap-1.5 p-5">
              <h3 className="m-0 font-display text-lg font-semibold leading-snug">{e(`items.${x.id}.title`)}</h3>
              <p className="m-0 text-[15px] leading-relaxed text-muted-foreground">{e(`items.${x.id}.text`)}</p>
            </div>
          </li>
        ))}
      </ul>
      <p className="m-0 text-sm text-muted-foreground">{e("credit")}</p>
    </div>
  );
};

export default EventTypesGrid;
